import { IInquiryDetails } from '@interfaces/inquiries';
import { ISupplementInquiry } from '@interfaces/supplements';

export const getInquirySupplementsFromList = (items: IInquiryDetails[], inquiryId: number) =>
  items.find(item => item.id === inquiryId)?.supplementInquiriesDto || [];

export const areAllSelected = (
  shareInquirySupplements: ISupplementInquiry[],
  shareSelectedSupplements: number[],
) =>
  shareInquirySupplements.every(item =>
    shareSelectedSupplements.includes(item.supplementInquiryId),
  );

export const changeAll = (shareInquirySupplements: ISupplementInquiry[], checked: boolean) =>
  checked ? shareInquirySupplements.map(item => item.supplementInquiryId) : [];

export const updateList = (
  shareSelectedSupplements: number[],
  supplementInquiryId: number,
  checked: boolean,
) =>
  checked
    ? [...shareSelectedSupplements, supplementInquiryId]
    : shareSelectedSupplements.filter(item => item !== supplementInquiryId);
